<template>
    <span
        v-if="internalValue"
        class="d-flex flex-nowrap gap-2"
    >
        <IconComp
            :icon="`fi-${internalValue.ISO2!.toLowerCase()}`"
            v-if="props.display == 'FlagAndCode' || props.display == 'FlagOnly' || props.display == 'Full'"
        />
        <span v-if="props.display == 'Full' || props.display == 'NameOnly'">{{
            $tm(internalValue!.TranslationKey ?? internalValue!.Name ?? '')
        }}</span>
        <span v-if="props.display == 'FlagAndCode' || props.display == 'CodeOnly'">{{ internalValue!.IOC }}</span>
    </span>
</template>

<script lang="ts" setup>
import type { Country } from '@/objects/generated';
import { useCommonStore } from '@/stores';
import { computed } from 'vue';
import IconComp from '../IconComp.vue';

const props = withDefaults(
    defineProps<{
        /**
         * The country to display. This can be a country object or a country id
         */
        value: number | Country;

        /**
         * If true, only the flag will be displayed, otherwise the name of the country will also be displayed. This is useful for when you want to display the country in a small space, like in a table.
         */
        display?: 'Full' | 'FlagOnly' | 'NameOnly' | 'FlagAndCode' | 'CodeOnly';
    }>(),
    {
        display: 'Full',
    },
);

const { Countries } = useCommonStore();

/**
 * The internal value of the country
 */
const internalValue = computed(() => {
    if (typeof props.value === 'number') {
        return Countries.find((c) => c.ID === props.value) ?? null;
    }
    return props.value;
});
</script>
